/**
 * @fileoverview Error Utility Functions
 * @description Utility functions for displaying error messages to users.
 *              Uses react-toastify for consistent toast notifications.
 *
 * @author Sabya (Sabyasachi Rout)
 * @version 1.1.0
 *
 * @changelog
 * - 2024-12-04: Simplified toast config to match success toast styling (Sabya)
 */

import { toast } from "react-toastify";

/**
 * Displays an error toast notification to the user
 * Uses default react-toastify styling to match success toasts
 *
 * @param {string} errorMessage - The error message to display
 * @example
 * showErrorToast("Failed to delete project");
 * showErrorToast("You do not have permission to perform this action");
 */
export function showErrorToast(errorMessage) {
  toast.error(errorMessage);
}
